export default {
  placeholders: []
}
  